export default {
  "home": "ДОМОЙ",
  "news": "НОВОСТИ",
  "community": "СООБЩЕСТВО",
  "character": "ПЕРСОНАЖИ",
  "world": "НАСТРОЙКИ МИРА",
  "features": "ФУНКЦИИ",
  "topUp": "ПОПОЛНЕНИЕ",
  "customerService": "СЛУЖБА ПОДДЕРЖКИ",
  "download": "СКАЧАТЬ",
  "moreDownload": "Другие способы загрузки",
  "screenshot": "СКРИНШОТ",
  "video": "СИНЕМАТИК",
  "poster": "ПЛАКАТ",
  "downloadGame": "СКАЧАТЬ",
  "scan": "Отсканируйте QR-код, чтобы скачать",
  "prev": "Пред.",
  "next": "След.",
  "moreNews": "ИНФОРМАЦИЯ",
  "latest": "НОВИНКИ",
  "fwtk": "TERMS OF SERVICE",
  "yszc": "PRIVACY POLICY",
  "noContent": "Пока нет содержания",
  "goPay": "ВПЕРЁД",
  "payGuide": "УЗНАТЬ БОЛЬШЕ",
  "stayTurn": "Пока нет содержания",
  "back": "Назад",
}
